export const SETISRELOAD = "SETISRELOAD"

export const setIsReload = (isReload) => ({
  type: SETISRELOAD,
  isReload
})

